import script from "./ActivityTripCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityTripCard.vue?vue&type=script&setup=true&lang=js"

import "./ActivityTripCard.vue?vue&type=style&index=0&id=681df4b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681df4b1"]])

export default __exports__